var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRateFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4312_37817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 6L33.1509 18.1766C33.3488 18.6443 33.6603 19.0489 34.0542 19.3498C34.448 19.6507 34.9103 19.8371 35.3944 19.8905L48 21.2786L38.5779 30.1924C38.216 30.5348 37.9463 30.9713 37.7958 31.4581C37.6454 31.9449 37.6195 32.4648 37.7209 32.9655L40.3607 46L29.3865 39.3324C28.965 39.0763 28.4869 38.9414 28 38.9414C27.5132 38.9414 27.035 39.0763 26.6135 39.3324L15.6393 46L18.2791 32.9655C18.3805 32.4648 18.3546 31.9449 18.2042 31.4581C18.0537 30.9713 17.784 30.5348 17.4221 30.1924L8 21.2786L20.6056 19.8905C21.0897 19.8371 21.552 19.6507 21.9458 19.3498C22.3397 19.0489 22.6512 18.6443 22.8491 18.1766L28 6Z",
    fill: "#FEED00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4312_37817",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.784314 0 0 0 0 0.0901961 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4312_37817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4312_37817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRateFill);
export default __webpack_public_path__ + "static/media/StarRateFill.2c5eb79179e755242887c3ff470b2c39.svg";
export { ForwardRef as ReactComponent };